export default "__VITE_ASSET__KoSkvlix__"